/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { StreamTimelineManager } from './StreamTimelineManager';
import { FirebaseConfiguration } from './model/FirebaseConfiguration';
import { FirestoreSettings } from './model/FirestoreSettings';
import { createStreamTimelineManager } from './StreamTimelineFactory';
import { StreamTimelineConfiguration } from './model/StreamTimelineConfiguration';
import { EventStore } from './EventStore';
import { ChangeType } from './model/ChangeType';
import { EventInfo } from './model/EventInfo';

const version = '__buildVersion__';

export {
  createStreamTimelineManager,
  ChangeType,
  EventStore,
  FirebaseConfiguration,
  StreamTimelineConfiguration,
  StreamTimelineManager,
  FirestoreSettings,
  EventInfo,
  version,
};
